import { defineRecipe } from "@chakra-ui/react";

const textRecipe = defineRecipe({
  base: {
    color: "text",
    textStyle: "body.standard"
  }
});

export default textRecipe;
